import { theme } from "..";

import { TBaseSVG } from "../../models";

export default ({
    title,
    color,
    className,
    onClick,
    strokeWidth,
}: TBaseSVG) => {
    return (
        <svg
            onClick={onClick}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className || "icon-checked"}
        >
            <title>{title}</title>
            <path
                d="M5 13l4 4L19 7"
                stroke={color || theme.white}
                strokeWidth={strokeWidth || "1.2"}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
